import * as React from 'react';
import { useRef } from 'react';
import { composeRef, raf } from '@rc-component/util';
import Tooltip from '../tooltip';
const SliderTooltip = React.forwardRef((props, ref) => {
    const { open, draggingDelete, value } = props;
    const innerRef = useRef(null);
    const mergedOpen = open && !draggingDelete;
    const rafRef = useRef(null);
    function cancelKeepAlign() {
        raf.cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = raf(() => {
            innerRef.current?.forceAlign();
            rafRef.current = null;
        });
    }
    React.useEffect(() => {
        if (mergedOpen) {
            keepAlign();
        }
        else {
            cancelKeepAlign();
        }
        return cancelKeepAlign;
    }, [mergedOpen, props.title, value]);
    return React.createElement(Tooltip, { ref: composeRef(innerRef, ref), ...props, open: mergedOpen });
});
if (process.env.NODE_ENV !== 'production') {
    SliderTooltip.displayName = 'SliderTooltip';
}
export default SliderTooltip;
